module.exports = __webpack_public_path__ + "media/images/members/trial_freelances/img_articles451_3-2-f7a9ccb39b1ab079dc3382b0c1ba87a4.png";